<template>
  <div>
    <el-button
      v-if="$hasPerm('tenant:activity_task_mgmt:add_user_type')"
      class="newAdd"
      @click="openDialog"
      size="mini"
      >添加类型</el-button
    >
    <el-dialog
      title="用户类型管理"
      :visible.sync="moveDialogVisible"
      width="40%"
      center
      @close="clear"
      :close-on-click-modal="false"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item
          label="用户名称"
          :label-width="formLabelWidth"
          prop="name"
        >
          <el-input
            v-model="form.name"
            class="searchIpt"
            autocomplete="off"
            placeholder="用户名称"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="用户类型"
          :label-width="formLabelWidth"
          prop="userType"
        >
          <el-select
            v-model="form.userType"
            placeholder="请选择用户类型"
            clearable
            :style="{ width: '100%' }"
            @change="handleChange"
          >
            <el-option
              v-for="(item, index) in userTypeOptions"
              :key="index.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="注册时间" prop="registerDay">
          <div class="flex">
            <el-select
              v-model="registerDayLogic"
              placeholder="请选择注册时间"
              clearable
              :style="{ width: '100%' }"
            >
              <el-option
                v-for="(item, index) in logicOptions"
                :key="`${index}+${item.value}`"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
            <el-input
              v-model="form.registerDay"
              class="searchIpt"
              autocomplete="off"
              placeholder="输入时长"
            >
              <template slot="append">天</template>
            </el-input>
          </div>
        </el-form-item>
        <el-form-item label="交易行为(次数)" prop="tradeNum">
          <div class="flex">
            <el-select
              v-model="tradeNumLogic"
              placeholder="请选择次数"
              clearable
              :style="{ width: '100%' }"
            >
              <el-option
                v-for="(item, index) in logicOptions"
                :key="`${item.value}${index}`"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
            <el-input
              v-model="form.tradeNum"
              class="searchIpt"
              autocomplete="off"
              placeholder="输入次数"
            >
              <template slot="append">次</template>
            </el-input>
          </div>
        </el-form-item>
        <el-form-item label="交易行为(交易量)" prop="tradeAmount">
          <div class="flex">
            <el-select
              v-model="tradeAmountLogic"
              placeholder="请选择交易量"
              clearable
              :style="{ width: '100%' }"
            >
              <el-option
                v-for="(item, index) in logicOptions"
                :key="`${item.label}${index}`"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
            <el-input
              v-model="form.tradeAmount"
              class="searchIpt"
              autocomplete="off"
              placeholder="输入数量"
            >
              <template slot="append">UDST</template>
            </el-input>
          </div>
        </el-form-item>
        <el-form-item label="登录间隔" prop="loginRangeDay">
          <div class="flex">
            <el-select
              v-model="loginRangeDayLogic"
              placeholder="请选择登录间隔"
              clearable
              :style="{ width: '100%' }"
            >
              <el-option
                v-for="(item, index) in logicOptions"
                :key="`${index}+${item.label}`"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-input
              v-model="form.loginRangeDay"
              class="searchIpt"
              autocomplete="off"
              placeholder="输入时长"
            >
              <template slot="append">天</template>
            </el-input>
          </div>
        </el-form-item>
        <el-form-item
          label="指定用户UID"
          :label-width="formLabelWidth"
          prop="whiteList"
          v-if="isWhiteListShow"
        >
          <el-input
            v-model="form.whiteList"
            class="searchIpt"
            autocomplete="off"
            type="textarea"
            :rows="5"
            placeholder="用英文逗号或空行隔开"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="clear">关闭</el-button>
        <el-button
          v-if="$hasPerm('tenant:activity_task_mgmt:add_user_type')"
          size="mini"
          type="primary"
          @click="add"
          >确认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'

export default {
  data() {
    return {
      moveDialogVisible: false,
      detailInfo: null,
      isAct: false,
      form: {
        name: '',
        registerDay: '',
        loginRangeDay: '',
        tradeNum: '',
        tradeAmount: '',
        userType: '',
        whiteList: '',
        tenantId: -1,
      },

      formLabelWidth: 'auto',
      rules: {
        name: [{ required: true, message: '请输入用户名称', trigger: 'blur' }],
        userType: [
          { required: true, message: '请选择用户类型', trigger: 'change' },
        ],
        registerDay: [
          { required: true, message: '请选择注册时间', trigger: 'blur' },
        ],
        tradeNum: [{ required: true, message: '请选择次数', trigger: 'blur' }],
        tradeAmount: [
          { required: true, message: '请输入数量', trigger: 'blur' },
        ],
        loginRangeDay: [
          { required: true, message: '请选择登录间隔', trigger: 'blur' },
        ],
        whiteList: [
          { required: true, message: '请输入指定用户UID', trigger: 'blur' },
        ],
      },
      registerDayLogic: '',
      tradeNumLogic: '',
      tradeAmountLogic: '',
      loginRangeDayLogic: '',
      logicOptions: [
        {
          label: '小于',
          value: '-',
        },
        {
          label: '大于',
          value: '+',
        },
      ],

      userTypeOptions: [
        // {
        //   label: '全部用户类型',
        //   value: 'ALL',
        // },
        {
          label: '白名单用户类',
          value: 'CONF',
        },
        {
          label: '条件用户类型',
          value: 'CONDITION',
        },
      ],
      isWhiteListShow: true,
    }
  },
  methods: {
    ...mapActions('partnerList', ['addPartner', 'getUserData']),
    ...mapActions('userTypeManagement', ['addUserType']),

    openDialog() {
      this.moveDialogVisible = true
    },

    add() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (!this.registerDayLogic) {
            this.$message.error('请选择注册时间逻辑')
            return
          }
          if (!this.tradeNumLogic) {
            this.$message.error('请选择交易行为(次数)逻辑')
            return
          }
          if (!this.tradeAmountLogic) {
            this.$message.error('请选择交易行为(交易量)逻辑')
            return
          }
          if (!this.loginRangeDayLogic) {
            this.$message.error('请选择登录间隔逻辑')
            return
          }
          const data = {
            ...this.form,
            loginRangeDay: Number(
              this.loginRangeDayLogic + this.form.loginRangeDay
            ),
            registerDay: Number(this.registerDayLogic + this.form.registerDay),
            tradeAmount: Number(this.tradeAmountLogic + this.form.tradeAmount),
            tradeNum: Number(this.tradeNumLogic + this.form.tradeNum),
            // userType: this.form.userType,
            // whiteList: this.form.whiteList,
            // name: this.form.name,
          }
          this.addUserType(data).then((res) => {
            if (res.code == 0) {
              this.$message.success('添加成功')
              this.$emit('refresh')
              this.clear()
            } else {
              this.$message.error('添加失败')
              this.clear()
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    clearFiled() {
      this.$refs['form'].resetFields()
    },
    clear() {
      this.moveDialogVisible = false
      this.$refs['form'].resetFields()
    },
    handleChange(val) {
      if (val === 'CONDITION') {
        this.isWhiteListShow = false
      } else {
        this.isWhiteListShow = true
      }
      this.form.whiteList = ''
    },
  },
}
</script>

<style lang="less" src="@/styles/button.less" scoped>
.content {
  // border: 1px solid #f5f6f7;
  padding: 20px;
  width: 100%;
  height: 200px;
  .up {
    border: 1px solid #f5f6f7;
    width: 100%;
    height: 50%;
    display: flex;
  }
  .down {
    border: 1px solid #f5f6f7;
    width: 100%;
    height: 50%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .item {
    border-right: 1px solid #f5f6f7;
    display: flex;
    width: 50%;
    height: 100%;
    justify-content: center;
    align-items: center;
    .ipt {
      width: 90%;
    }
  }
}
.btn1 {
  display: flex;
  justify-content: center;
  width: 300px;
  margin: 0 auto;
}
</style>
<style lang="less" scoped>
.langTab {
  cursor: pointer;
  margin-right: 20px;
  display: inline-block;
}
.task {
  border: 1px solid #000;
  padding: 12px;
}

.flex {
  display: flex;
  gap: 12px;
  align-items: center;
}
.addTask {
}
</style>
